import Styles from './Digistudies.scss';

import Template from './Digistudies.hbs';
import Spinner from 'views/components/spinner/Spinner';
import LoadExternalStaticResources from 'util/LoadExternalStaticResources.js';

export default class Digistudies extends BaseView {

    /**
     * Method wich would be called after this view is added to
     * the DOM. Using the logic as defined in BaseView
     *
     * @memberof Digistudies
     */
    show() {
        this.addChildView(
            new Spinner({}),
            '.js-spinner'
        );
    }

    /**
     * Method that will be called on initialization of
     * this class. It will render the template and start
     * loading the video.
     *
     * @param {Object} {
     *  fileId {String} containing the edufiles id associated with this video
     *  fileIdHash {String} containing the the edufiles hash for this video
     * }
     * @memberof Digistudies
     */
    initialize({ fileId, fileIdHash, isVideoActivity }) {

        this.isVideoActivity = isVideoActivity;

        _.bindAll(this,
            'onGetVideoDetailsInitPlayer'
        );

        this.setElement(Template({
            isVideoActivity,
            Styles
        }));

        this.loadVideoDetails({
            fileId,
            fileIdHash
        });
    }

    /**
     * Executes an AJAX call to get the video details to edufiles.
     * It will receive the real video url and video token.
     *
     * @param {Object} {
     *  fileId {String} containing the edufiles id associated with this video
     *  fileIdHash {String} containing the the edufiles hash for this video
     * }
     * @memberof Digistudies
     */
    loadVideoDetails({ fileId, fileIdHash }) {
        $.get({
            url: `/edu_files/open/${fileId}${(fileIdHash) ? `/${fileIdHash}` : ''}`,
            success: this.onGetVideoDetailsInitPlayer
        });
    }

    /**
     * This method will be called when the details of the video are
     * received correctly trough edufiles. It will load the external
     * resources, and call onLoadedResource for both external resources
     * when loaded.
     *
     * @param {Object} data object containing information about the Digistudies video
     * @memberof Digistudies
     */
    onGetVideoDetailsInitPlayer(data) {

        // If we don't get a token, the video will be broken, so log it
        if (!data.token) {
            this.$('.js-spinner').hide()
            this.$('.js-error').text(window.i18n.gettext('This video is outdated and therefore not available anymore.'))
            window.sentry.captureMessage('Digistudies video is broken (missing token)', 'error')
            return
        }

        const LESR = LoadExternalStaticResources();

        // Load Azureplayer CSS
        LESR.addResource({
            identifier: 'DigistudiesCSS',
            url: '//amp.azure.net/libs/amp/2.3.6/skins/amp-default/azuremediaplayer.min.css',
            type: 'css'
        }, () => {
            this.loadedCSS = true;
            this.onLoadedResource(data);
        });

        // Load Azureplayer JS
        LESR.addResource({
            identifier: 'DigistudiesJS',
            url: '//amp.azure.net/libs/amp/2.3.6/azuremediaplayer.min.js',
            type: 'javascript'
        }, () => {
            this.loadedJS = true;
            this.onLoadedResource(data);
        });
    }

    /**
     * Will be called for each loaded external resource. If
     * both are loaded, it will initialize the Azure player
     * using the given information from edufiles
     *
     * @param {Object} {
     *  videoUrl {string} containing the real digistudies video url
     *  token {string} containing the token to decrypt the video source
     * }
     * @memberof Digistudies
     */
    onLoadedResource({ videoUrl, token }) {

        if (this.loadedCSS && this.loadedJS) {
            const videoElementId = `digistudies-player-${this.cid}`;

            const playerVideoElement = document.createElement('video');
            playerVideoElement.classList.add('azuremediaplayer');
            playerVideoElement.classList.add('amp-default-skin');
            playerVideoElement.classList.add('amp-big-play-centered');
            playerVideoElement.tabIndex = 0;
            playerVideoElement.id = videoElementId;

            this.$el.empty();
            this.$el.append(playerVideoElement);

            const azurePlayer = window.amp(
                videoElementId,
                {
                    width: (this.isVideoActivity) ? '100%' : '640',
                    height: (this.isVideoActivity) ? '100%' : '400',
                    logo: { enabled: false },
                    controls: true,
                }
            );

            azurePlayer.src([{
                src: videoUrl,
                type: 'application/vnd.ms-sstr+xml',
                protectionInfo: [{
                    type: 'AES',
                    authenticationToken: token
                }]
            }]);

            window.statsTracker.trackEvent(
                window.app.controller.activePath.join('/'),
                'Digistudies video opened'
            )
        }
    }
}
